import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tCentro/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{ searchQuery: any }>;

export const DispatchSetBlogSearchQuery: HandlerType = props => {
    props.dispatch({
        type: "Custom/Article/SetBlogSearchQuery",
        searchQuery: props.parameter.searchQuery,
    });
};

export const chain = [DispatchSetBlogSearchQuery];

const CENSetBlogSearchQuery = createHandlerChainRunner(chain, "CENSetBlogSearchQuery");
export default CENSetBlogSearchQuery;
